import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401) {
      // console.log(
      //   'this.router.routerState.snapshot: ',
      //   this.router.routerState.snapshot
      // );
      if (this.router.routerState.snapshot.url == '/client-login') {
        this.router.navigate(['/client-login']);
      } else {
        this.router.navigate(['/']);
      }
      localStorage.clear();
    }
    return throwError(err);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    if (token) {
      if (window.location.href.indexOf('commons') > -1) {
        request = request.clone();
      } else {
        request = request.clone({
          headers: request.headers.set('x-access-token', token),
        });
        if (!request.headers.has('Content-Type') && request.url.indexOf('with-formdata') == -1) {
          request = request.clone({
            headers: request.headers.set('Content-Type', 'application/json'),
          });
        }
      }
      request = request.clone({
        headers: request.headers
          .set('Accept', 'application/json')
          .set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache'),
      });
    } else {
      request = request.clone();
    }
    return next.handle(request).pipe(
      map((event: any) => {
        if (event instanceof HttpResponse) {
          if (event.status === 403 || event.body.status === 403) {
            this.router.navigate(['/']);
            return;
          } else if (event.body && event.body.token) {
            localStorage.setItem('token', event.body.token);
          }
        }
        return <any>event;
      }),
      catchError(x => this.handleAuthError(x))
    );
  }
}
